import { render, staticRenderFns } from "./TabList.vue?vue&type=template&id=a32b0b08&scoped=true"
import script from "./TabList.vue?vue&type=script&lang=js"
export * from "./TabList.vue?vue&type=script&lang=js"
import style0 from "./TabList.vue?vue&type=style&index=0&id=a32b0b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32b0b08",
  null
  
)

export default component.exports